import React from 'react';

interface DocumentPlusIconProps {
    className?: string;
}

export const DocumentPlusIcon: React.FC<DocumentPlusIconProps> = ({ className }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
            focusable="false"
        >
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="12" y1="16" x2="18" y2="16" />
            <line x1="15" y1="13" x2="15" y2="19" />
        </svg>
    );
};

export default DocumentPlusIcon;
